export enum RecentlyViewedEntityEnum {
  SUBSCRIPTION = 'subscription',
  CUSTOMER_ADDRESS = 'customer_address',
  CLOUD_SITE = 'cloud_site',
  QUOTE = 'quote',
  INVOICE = 'invoice',
  ORDER = 'order',
  BILLING_PROFILE = 'billing_profile',
  EMAIL = 'email',
  REFUND = 'refund',
}

export const MAX_APP_STORAGE = 50;
export const MAX_ENTITY_STORAGE = 20;
